import { Definition } from './definition';

export class DefinitionCategory {
    constructor(public id: number, public name: string, public definitions: Definition[]) {}

    public static fromAny(item: any): DefinitionCategory {
        return new DefinitionCategory(
            item.id,
            item.name,
            (item.definitions || []).map(Definition.fromAny)
        );
    }
}
